import {ThunkResult} from '../../store'
import {
    replaceResult,
    replaceResultData,
    replaceSearchFallback
} from './SystemLabels.slice'
import systemLabelApi from '../../apis/systemLabel.api'
import {PaginateResponse, PaginateWithTypeRequest} from '../../services/api.service'
import customLabelService from '../../services/customLabel.service'
import storageService from '../../services/storage.service'
import customLabelApi from '../../apis/customLabel.api'

export function paginate(): ThunkResult<void> {
    return (dispatch, getState) => {
        let {page, limit, search, labelableType, sortBy} = getState().systemLabels

        const searchStr = storageService.get('customLabelSearch')
        const labelableTypeStr = storageService.get('systemLabelSearch')
        const pageStr = storageService.get('customLabelPage')
        const limitStr = storageService.get('customLabelLimit')
        const sortByStr = storageService.get('customLabelSorting')

        if (pageStr != '' && pageStr != null && pageStr != undefined) {
            page = pageStr
        }

        if (searchStr != '' && searchStr != null && searchStr != undefined) {
            search = searchStr
        }

        if (labelableTypeStr != '' && labelableTypeStr != null && labelableTypeStr != undefined) {
            labelableType = labelableTypeStr
        }

        if (limitStr != '' && limitStr != null && limitStr != undefined) {
            limit = limitStr
        }

        if (sortByStr != '' && sortByStr != null && sortByStr != undefined) {
            sortBy = sortByStr
        }

        const params: PaginateWithTypeRequest = {
            page,
            limit,
            search,
            labelableType,
            sortBy
        }

        const handlePaginate = (paginate: PaginateResponse<any[]>) => {
            if (!paginate) return

            const hasSearch = typeof search === 'string' && search.trim() !== ''
            const normalizedSearch = search.trim().toLowerCase()

            if (labelableType !== 'customLabel' && hasSearch) {
                const filteredData = paginate.data.filter((label: {name: string}) =>
                    label.name.toLowerCase().includes(normalizedSearch)
                )

                const isSearchFallback = filteredData.length !== paginate.data.length

                dispatch(replaceSearchFallback(isSearchFallback))

                if (isSearchFallback) {
                    dispatch(replaceResult({
                        ...paginate,
                        data: filteredData,
                        total: filteredData.length,
                        from: filteredData.length ? 1 : null,
                        to: filteredData.length || null,
                        currentPage: filteredData.length ? 1 : 0,
                        lastPage: filteredData.length ? 1 : 0
                    } as any))
                    return
                }
            } else {
                dispatch(replaceSearchFallback(false))
            }

            dispatch(replaceResult(paginate as any))
        }

        if (labelableType === 'customLabel') {
            customLabelApi.paginate(params as any, paginate => handlePaginate(paginate as any))
            return
        }

        systemLabelApi.paginate(params, paginate => handlePaginate(paginate as any))
    }
}

export function deleteCustomLabel(id: number): ThunkResult<void> {
    return (dispatch, getState) => {
        customLabelApi.delete(id, customLabel => {
            if (!customLabel) return
            const {result} = getState().customLabels
            const data = customLabelService.delete(result.data, id)
            dispatch(replaceResultData(data))
        })
    }
}
